export default __webpack_public_path__ + "static/media/ill-no-test.f1820568.svg";